module.exports = __webpack_public_path__ + "2b3795ac8a11c1be4bf019ef102eb194.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/pink-heart-glasses-s.png
// module id = 2375
// module chunks = 0